export default __webpack_public_path__ + "static/media/tabuleiro-desfocado.df4a3303.webp";